import { createContext } from "react";

export const ChefDetailsContext = createContext({});

export default ChefDetailsContext;
